var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drop-shadow-md py-3",staticStyle:{"background-color":"var(--color-braun-light)"}},[_c('div',{staticClass:"grid justify-items-end"},[_c('img',{staticClass:"h-[3rem]",attrs:{"src":require("@/assets/Grafiken/kgc-logo-weiss.svg")}})])])
}]

export { render, staticRenderFns }